export default __webpack_public_path__ + "static/media/edge-logo.226012e6.svg";